// Audio player dropdown icons
export const CoverIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-shrink-0 w-4 h-4"
  >
    <path
      d="M1.83091 5.88108C2.71458 3.07412 5.42504 1.13406 8.48696 1.34958L8.48764 1.34963C10.6279 1.5025 12.4467 2.66619 13.5168 4.34118L13.6148 4.04917C13.732 3.70012 14.1099 3.51215 14.459 3.62932C14.808 3.74649 14.996 4.12444 14.8788 4.47349L14.2455 6.36016C14.1283 6.7092 13.7504 6.89718 13.4013 6.78L11.5147 6.14667C11.1656 6.0295 10.9776 5.65155 11.0948 5.30251C11.212 4.95346 11.5899 4.76548 11.939 4.88266L12.3739 5.02864C11.5199 3.71163 10.0821 2.80035 8.39297 2.67959C5.9617 2.50863 3.80567 4.04852 3.10271 6.28146C2.99215 6.63265 2.61782 6.82773 2.26662 6.71717C1.91542 6.6066 1.72035 6.23227 1.83091 5.88108Z"
      fill="currentColor"
    />
    <path
      d="M9.4135 8.01461C9.4135 8.81727 8.76282 9.46795 7.96017 9.46795C7.15752 9.46795 6.50684 8.81727 6.50684 8.01461C6.50684 7.21196 7.15752 6.56128 7.96017 6.56128C8.76282 6.56128 9.4135 7.21196 9.4135 8.01461Z"
      fill="currentColor"
    />
    <path
      d="M13.6537 9.31871C14.0049 9.42927 14.2 9.8036 14.0894 10.1548C13.2055 12.9626 10.4878 14.9018 7.42672 14.6863L7.42603 14.6862C5.28575 14.5334 3.46695 13.3697 2.3969 11.6947L2.29886 11.9868C2.18168 12.3358 1.80374 12.5238 1.45469 12.4066C1.10564 12.2895 0.917669 11.9115 1.03484 11.5625L1.66817 9.6758C1.78535 9.32675 2.16329 9.13878 2.51234 9.25595L4.39901 9.88928C4.74805 10.0065 4.93603 10.3844 4.81886 10.7334C4.70168 11.0825 4.32374 11.2705 3.97469 11.1533L3.53988 11.0073C4.39387 12.3243 5.83168 13.2356 7.52082 13.3563C9.95288 13.5273 12.1149 11.9865 12.8176 9.75442C12.9282 9.40322 13.3025 9.20814 13.6537 9.31871Z"
      fill="currentColor"
    />
  </svg>
);

export const ExtendIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-shrink-0 w-4 h-4"
  >
    <path
      d="M2.66667 12C2.47778 12 2.31944 11.9361 2.19167 11.8083C2.06389 11.6806 2 11.5222 2 11.3333V4.66667C2 4.47778 2.06389 4.31944 2.19167 4.19167C2.31944 4.06389 2.47778 4 2.66667 4C2.85556 4 3.01389 4.06389 3.14167 4.19167C3.26944 4.31944 3.33333 4.47778 3.33333 4.66667V11.3333C3.33333 11.5222 3.26944 11.6806 3.14167 11.8083C3.01389 11.9361 2.85556 12 2.66667 12Z"
      fill="currentColor"
    />
    <path
      d="M12.1168 7.33322L6.00016 7.33322C5.81127 7.33322 5.65294 7.39711 5.52516 7.52489C5.39738 7.65266 5.3335 7.811 5.3335 7.99989C5.3335 8.18877 5.39738 8.34711 5.52516 8.47489C5.65294 8.60266 5.81127 8.66655 6.00016 8.66655H12.1168L10.2002 10.5999C10.0779 10.7221 10.0141 10.8749 10.0085 11.0582C10.0029 11.2416 10.0668 11.3999 10.2002 11.5332C10.3224 11.6554 10.4779 11.7166 10.6668 11.7166C10.8557 11.7166 11.0113 11.6554 11.1335 11.5332L14.2002 8.46655C14.2668 8.39989 14.3141 8.32766 14.3418 8.24989C14.3696 8.17211 14.3835 8.08877 14.3835 7.99989C14.3835 7.911 14.3696 7.82766 14.3418 7.74989C14.3141 7.67211 14.2668 7.59989 14.2002 7.53322L11.1335 4.46655C11.0113 4.34433 10.8585 4.28322 10.6752 4.28322C10.4918 4.28322 10.3335 4.34433 10.2002 4.46655C10.0668 4.59989 10.0002 4.75822 10.0002 4.94155C10.0002 5.12489 10.0668 5.28322 10.2002 5.41655L12.1168 7.33322Z"
      fill="currentColor"
    />
  </svg>
);

export const IntroIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-shrink-0 w-4 h-4"
  >
    <path
      d="M3.88317 8.66678H9.99984C10.1887 8.66678 10.3471 8.60289 10.4748 8.47511C10.6026 8.34734 10.6665 8.189 10.6665 8.00011C10.6665 7.81123 10.6026 7.65289 10.4748 7.52511C10.3471 7.39734 10.1887 7.33345 9.99984 7.33345H3.88317L5.79984 5.40011C5.92206 5.27789 5.98595 5.12511 5.9915 4.94178C5.99706 4.75845 5.93317 4.60011 5.79984 4.46678C5.67761 4.34456 5.52206 4.28345 5.33317 4.28345C5.14428 4.28345 4.98873 4.34456 4.8665 4.46678L1.79984 7.53345C1.73317 7.60011 1.68595 7.67234 1.65817 7.75011C1.63039 7.82789 1.6165 7.91123 1.6165 8.00011C1.6165 8.089 1.63039 8.17234 1.65817 8.25011C1.68595 8.32789 1.73317 8.40011 1.79984 8.46678L4.8665 11.5334C4.98873 11.6557 5.1415 11.7168 5.32484 11.7168C5.50817 11.7168 5.6665 11.6557 5.79984 11.5334C5.93317 11.4001 5.99984 11.2418 5.99984 11.0584C5.99984 10.8751 5.93317 10.7168 5.79984 10.5834L3.88317 8.66678Z"
      fill="currentColor"
    />
    <path
      d="M13.3332 12C13.1443 12 12.9859 11.9361 12.8582 11.8083C12.7304 11.6806 12.6665 11.5222 12.6665 11.3333V4.66667C12.6665 4.47778 12.7304 4.31944 12.8582 4.19167C12.9859 4.06389 13.1443 4 13.3332 4C13.5221 4 13.6804 4.06389 13.8082 4.19167C13.9359 4.31944 13.9998 4.47778 13.9998 4.66667V11.3333C13.9998 11.5222 13.9359 11.6806 13.8082 11.8083C13.6804 11.9361 13.5221 12 13.3332 12Z"
      fill="currentColor"
    />
  </svg>
);

export const SpeedIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-shrink-0 w-4 h-4"
  >
    <path
      d="M8.00016 1.33325C11.6764 1.33325 14.6668 4.32369 14.6668 7.99992C14.6668 11.6762 11.6764 14.6666 8.00016 14.6666C7.57063 14.6666 7.22449 14.3204 7.22449 13.8909C7.22449 13.4614 7.57063 13.1152 8.00016 13.1152C10.8208 13.1152 13.1155 10.8206 13.1155 7.99992C13.1155 5.17925 10.8208 2.8846 8.00016 2.8846C5.17949 2.8846 2.88484 5.17925 2.88484 7.99992C2.88484 8.42945 2.5387 8.77559 2.10917 8.77559C1.67964 8.77559 1.3335 8.42945 1.3335 7.99992C1.3335 4.32369 4.32393 1.33325 8.00016 1.33325Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.63249 4.92104C9.93612 4.67401 10.3859 4.6917 10.6686 4.97424C10.9511 5.25692 10.9688 5.70671 10.7218 6.01032L10.6686 6.06907L9.48641 7.25044C9.5496 7.42026 9.58878 7.60534 9.58883 7.79985V7.80382C9.58875 8.68146 8.87777 9.39147 8.00016 9.39169C7.12254 9.39149 6.41237 8.68147 6.41229 7.80382C6.41229 6.9261 7.12249 6.21614 8.00016 6.21595C8.10523 6.21599 8.20445 6.23096 8.29709 6.25009L9.57374 4.97424L9.63249 4.92104ZM6.59966 8.07375C6.60063 8.07881 6.60182 8.08381 6.60284 8.08884C6.59362 8.0433 6.58697 7.99691 6.5822 7.9499L6.59966 8.07375ZM9.42528 7.79985V7.80382C9.42527 7.89921 9.41611 7.99237 9.39828 8.08249C9.4069 8.03895 9.41437 7.99478 9.41892 7.9499L9.42528 7.80382V7.79985ZM9.29586 7.21154C9.33615 7.30087 9.36881 7.39566 9.39114 7.49418L9.35065 7.34889C9.33478 7.30192 9.31593 7.25605 9.29586 7.21154ZM7.32453 6.54781C7.24204 6.59221 7.16434 6.64426 7.0927 6.70342L7.20305 6.62165C7.24224 6.59519 7.28269 6.57037 7.32453 6.54781ZM8.00016 6.37791C8.1227 6.37792 8.23825 6.39913 8.35029 6.42714L8.17959 6.3922C8.15069 6.38786 8.12107 6.38429 8.09147 6.38188L8.00016 6.37791Z"
      fill="currentColor"
    />
  </svg>
);

export const ReplaceIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-shrink-0 w-4 h-4"
    preserveAspectRatio="none"
  >
    <path
      d="M0.884342 13.2399C0.457676 13.2399 0.117676 12.8933 0.117676 12.4733V4.09992C0.117676 3.67325 0.457676 3.33325 0.884342 3.33325C1.31101 3.33325 1.65101 3.67325 1.65101 4.09992V12.4733C1.65101 12.8933 1.31101 13.2399 0.884342 13.2399Z"
      fill="currentColor"
    />
    <path
      d="M12.851 5.05993C12.851 4.6866 12.551 4.3866 12.1777 4.3866H3.81101C3.43767 4.3866 3.13768 4.6866 3.13768 5.05993V11.5133C3.13768 11.8866 3.43767 12.1866 3.81101 12.1866H12.1777C12.551 12.1866 12.851 11.8866 12.851 11.5133V5.05993Z"
      fill="currentColor"
    />
    <path
      d="M14.3377 12.4733C14.3377 12.8933 14.6843 13.2399 15.1043 13.2399C15.5243 13.2399 15.871 12.8933 15.871 12.4733V4.09992C15.871 3.67325 15.5243 3.33325 15.1043 3.33325C14.6843 3.33325 14.3377 3.67325 14.3377 4.09992V12.4733Z"
      fill="currentColor"
    />
  </svg>
);

export const KaraokeIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-shrink-0 w-4 h-4"
  >
    <path
      d="M7.96479 9.33337C7.41146 9.33337 6.93813 9.14004 6.55146 8.74671C6.16479 8.36004 5.96479 7.88671 5.96479 7.33337V3.33337C5.96479 2.78004 6.15813 2.30671 6.55146 1.92004C6.93813 1.53337 7.41146 1.33337 7.96479 1.33337C8.51813 1.33337 8.99146 1.52671 9.37813 1.92004C9.76479 2.31337 9.96479 2.78004 9.96479 3.33337V7.33337C9.96479 7.88671 9.77146 8.36004 9.37813 8.74671C8.98479 9.13337 8.51813 9.33337 7.96479 9.33337ZM7.96479 14C7.59813 14 7.29813 13.7 7.29813 13.3334V12.5334C7.29813 12.2 7.05146 11.92 6.72479 11.84C5.82479 11.6067 5.05813 11.1267 4.43146 10.4C3.82479 9.69337 3.45813 8.89337 3.33813 8.00004C3.29146 7.63337 3.59146 7.33337 3.96479 7.33337C4.33146 7.33337 4.62479 7.63337 4.69146 7.99337C4.81146 8.63337 5.11813 9.20004 5.60479 9.68671C6.25813 10.3334 7.03813 10.66 7.96479 10.66C8.89146 10.66 9.67146 10.3334 10.3248 9.68671C10.8115 9.20004 11.1181 8.63337 11.2381 7.99337C11.3048 7.63337 11.5981 7.33337 11.9648 7.33337C12.3315 7.33337 12.6381 7.63337 12.5915 8.00004C12.4715 8.89337 12.1115 9.69337 11.4981 10.4C10.8715 11.1267 10.1048 11.6067 9.2048 11.84C8.87813 11.92 8.63146 12.2 8.63146 12.5334V13.3334C8.63146 13.7 8.33146 14 7.96479 14Z"
      fill="currentColor"
    />
  </svg>
);